/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";
import PipelineModal from "../pipeline-modal";
import px2rem from "../../utils/px2rem";
import CountDown from "../../utils/countDown";

class PipelineImgList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisibles: [],
      showDownloadModal: false
    };
    this.app_version = '';
    this.is_iframe = utils.getParams('isIframe') == 1;
  }

  componentDidMount() {
    this.app_version = utils.getVersion();
    const { imgsList } = this.props.config;
    let showView = true;
    imgsList && imgsList.map((item) => {
      if (item.src && item.behaviorType === '点击扫码(IOS >= 7.14 Android >= 7.17 可用)') {
        showView = this.showImg();
      } else if (!item.src) {
        showView = false;
      }
    })
    if (imgsList && imgsList.length == 1 && !showView && this.ref) {
      this.ref.parentNode.style.minHeight = 0
      this.ref.parentNode.style.height = 0
    }
  }

  showImg = () => {
    if (utils.isShihuo()) {
      if (!utils.isAndroid() && utils.SHDiffVersion(this.app_version, '7.14.0')) return true
      if (utils.isAndroid() && utils.SHDiffVersion(this.app_version, '7.17.0')) return true
      return false;
    }
    return true
  }
  handleItemClick = (item, index) => {
    // 当选择的点击事件是扫码
    if (item.behaviorType === '点击扫码(IOS >= 7.14 Android >= 7.17 可用)') {
      if (utils.isShihuo() && this.showImg()) {
        window.Jockey.send("scanCode", { from: 'h5-imgList', promptText: '扫描二维码/条码', authText: '识货请求使用相机权限，以便完成扫码验证功能', timeout: 10, codeType: 'all' }, (data) => {
          const { code = '', msg = '' } = data || {};
          if (code == 0) {
            if (msg.indexOf("http") == 0) {
              const baseConfig = this.props.config.baseConfig;
              const options = {
                link: msg,
                type: baseConfig.sortType,
                sort: index,
              };
              const convertUrl = utils.convertHref(msg);
              utils.jumpToUrl(this.props.routeParams, convertUrl, msg, options, -1, this.props, false);
            } else {
              utils.toast('非有效网页链接')
            }
          } else {
            utils.toast(msg)
          }
        });
      }
      return;
    }
    // 当选择的点击事件是弹窗
    if (item.behaviorType === '唤起弹窗') {
      const { modalVisibles } = this.state;
      modalVisibles[index] = true
      this.setState({
        modalVisibles
      });
      return;
    }

    if (this.props.templateName === 'toufang') {
      const params = {
        link: item.link || "",
        props: this.props,
        index
      }
      if (item.behaviorType === '唤起下载APP弹窗') {
        Object.assign(params, {
          clickType: 'openModal'
        });
        this.setState({
          showDownloadModal: true
        })
      }
      utils.handleToufangClick(params);
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: item.link,
      type: baseConfig.sortType,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams, convertUrl, item.link, options, -1, this.props, false);

  }

  handleDownloadModalClick = () => {
    utils.handleToufangClick({
      link: "https://wwww.shihuo.cn",
      props: this.props,
      clickType: 'modalClick'
    })
  }

  handleCloseDownloadModal = () => {
    const longurl = utils.getParams('longurl') || '';
    const from = longurl ? utils.getUrlParams(longurl, 'from') : '';
    const block = this.props.customAttributes["data-component-block"];
    window.sa && window.sa.track('pcClick', {
      env: 'toufang',
      version: '1.0.0',
      extra: from,
      action: `${block}`,
      page: window.location.href,
      data: JSON.stringify({
        clickType: 'closeModal',
      })
    });
    this.setState({
      showDownloadModal: false
    })
  }

  render() {
    const { modalVisibles, showDownloadModal } = this.state
    const { allModals = [], designIntent } = this.props
    const { baseConfig, imgsList } = this.props.config;

    let marginLeft = `${baseConfig.moduleMarginHorizon}px`;
    let marginRight = `${baseConfig.moduleMarginHorizon}px`;
    let imgListPadding = `${baseConfig.moduleMarginHorizon}px`;

    if (this.props.templateName === 'toufang') {
      // 投放模版，图片组件满足以下情形时，不展示左右边距
      const { sortType, layout_1 = {} } = baseConfig;
      if (
        sortType === '一行一图'
          && layout_1.imgMarginHorizon == '12'
          && layout_1.imgMarginVertical == '0'
          && layout_1.moduleMarginHorizon == '12'
          && layout_1.moduleMarginTop == '0'
      ) {
        marginLeft = 0;
        marginRight = 0;
      }
    }

    // 判断不同布局方式下的间距取值
    if (baseConfig.sortType === "一行一图") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.sortType === "一行二图") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.sortType === "一行三图") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.sortType === "一行多图") {
      Object.assign(baseConfig, baseConfig.layout_multiple);
      marginLeft = '0px';
      marginRight = '0px';
    } else if (baseConfig.sortType === "banner") {
      Object.assign(baseConfig, baseConfig.layout_banner);
    }

    // 转为数字处理，后续参与计算
    baseConfig.imgMarginHorizon = isNaN(Number(baseConfig.imgMarginHorizon))
      ? 0
      : Number(baseConfig.imgMarginHorizon);
    baseConfig.imgMarginVertical = isNaN(Number(baseConfig.imgMarginVertical))
      ? 0
      : Number(baseConfig.imgMarginVertical);

    if (designIntent && (baseConfig.title || baseConfig.subTitle) && imgsList.length > 0 && imgsList[0].src.indexOf('51663af5c613f3514e365ad71478ac4a') >= 0) {
      // 当组件包含设计意图，且存在住标题或副标题，且存在占位图片时，渲染自定义占位元素
      return (
        <div
          className="pipeline-imgList design-intent"
          id={this.props['customAttributes']['data-component-id']}
          name={baseConfig.title}
          {...this.props['customAttributes']}
          style={{
            marginTop: `${baseConfig.moduleMarginTop}px`,
            marginLeft,
            marginRight
          }}
        >
          {baseConfig.title && <p className="main-title">{baseConfig.title}</p>}
          {baseConfig.subTitle && <p className="sub-title">{baseConfig.subTitle}</p>}
        </div>
      )
    }

    return (
      <div
        ref={ref => this.ref = ref}
        className="pipeline-imgList"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft,
          marginRight
        }}
      >
        <div
          className={baseConfig.sortType === '一行多图' ? 'img-list multiple' : 'img-list'}
          style={{
            paddingLeft: baseConfig.sortType === '一行多图' && imgListPadding,
            paddingRight: baseConfig.sortType === '一行多图' && imgListPadding
          }}
        >
          {imgsList.map((item, index) => {
            let rowItemNumber = 1; // 每行排列数量
            if (
              baseConfig.sortType === "一行一图" ||
              baseConfig.sortType === "banner"
            ) {
              rowItemNumber = 1;
            } else if (baseConfig.sortType === "一行二图") {
              rowItemNumber = 2;
            } else if (baseConfig.sortType === "一行三图") {
              rowItemNumber = 3;
            }

            const targetModal = allModals.find(value => value.id === item.targetModal);
            const isFirstRow = Boolean(index < rowItemNumber); // 该项是否在首行
            const isLasthRow = Boolean(imgsList.length - index <= rowItemNumber); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

            // 计算每个项的宽度
            const totalMargin =
              (rowItemNumber - 1) * baseConfig.imgMarginHorizon;
            let itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;

            // 判断图片圆角值
            let imgBorderRadius = "6px";
            if (baseConfig.sortType === "banner" || baseConfig.noImgRadius) {
              // banner图片或者选择不添加圆角情况，值为0
              imgBorderRadius = "0";
            }

            if (baseConfig.sortType === "一行多图") {
              itemWidth = px2rem(`${baseConfig.layout_multiple.imgWidth || 100}px`)
            }

            // const { height } = utils.getAdaptImageSize(item.size);

            const itemStyle = {
              width: itemWidth,
              // height: height,
              borderRadius: imgBorderRadius,
              marginTop: isFirstRow
                ? "0"
                : `${baseConfig.imgMarginVertical / 2}px`,
              marginBottom: isLasthRow
                ? "0"
                : `${baseConfig.imgMarginVertical / 2}px`,
              marginLeft: (isFirstColumn && baseConfig.sortType != "一行多图")
                ? "0"
                : `${baseConfig.imgMarginHorizon / 2}px`,
              marginRight: (isLastColumn && baseConfig.sortType != "一行多图")
                ? "0"
                : `${baseConfig.imgMarginHorizon / 2}px`,
            };

            let imgItem;
            if (item.src) {
              imgItem = (
                <Fragment key={index}>
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {
                      link: item.link,
                      type: baseConfig.sortType,
                      sort: index,
                    }))}
                    className={baseConfig.sortType === '一行多图' ? 'img-item multiple' : 'img-item'}
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemClick.bind(this, item, index)}
                  >
                    {
                      item.openCountDown && item.countDownTime && (
                        <CountDown
                          countDownTime={item.countDownTime}
                          countDownTextColor={item.countDownTextColor}
                          countDownBgColor={item.countDownBgColor}
                        />
                      )
                    }
                    <LazyLoadImage
                      src={utils.formatImgUrl(item.src, this.props.webpSupport)}
                      style={{
                        width: itemWidth,
                        // height: height
                      }}
                      effect="opacity"
                      visibleByDefault={true}
                    />
                  </div>
                  {
                    targetModal &&
                    <PipelineModal
                      customAttributes={{
                        "data-component-id": targetModal.id,
                        "data-component-name": targetModal.name,
                        "data-component-block": targetModal.blockName,
                      }}
                      config={targetModal.data}
                      triggerId={this.props['customAttributes']["data-component-id"]}
                      visible={modalVisibles[index]}
                      onClose={() => {
                        modalVisibles[index] = false
                        this.setState({
                          modalVisibles
                        })
                      }}
                    />
                  }
                </Fragment>
              );
              if (item.behaviorType === '点击扫码(IOS >= 7.14 Android >= 7.17 可用)') {
                if (!this.showImg()) {
                  imgItem = null;
                }
              }

            } else {
              imgItem = null;
            }
            return imgItem;
          })}
        </div>
        {
          this.props.templateName === 'toufang' && 
          <div className={showDownloadModal ? "pipeline-downloadModal show" : "pipeline-downloadModal"}>
            <div className={showDownloadModal ? "modal-content show" : "modal-content"}>
              <img className="modal-img" alt="" src={utils.formatImgUrl("https://static.shihuocdn.cn/admin/files/20230227/54917266bd550bf120101644116385fb.png", this.props.webpSupport)}  />
              <div 
                className="bottom-btns"
                style={{
                  width: px2rem('215px'),
                  height: "40px"
                }}
                onClick={this.handleDownloadModalClick.bind(this)}
              >
                  <div
                    className="btn-item"
                  >
                    {/* <img
                      alt=""
                      src={utils.formatImgUrl("https://static.shihuocdn.cn/admin/files/20230214/e3705c11aff348bf64493120c0586a65.png", this.props.webpSupport)}
                      style={{
                        width: px2rem('100px'),
                        height: 'auto',
                      }}
                    /> */}
                    <span>立即下载</span>
                    </div>
              </div>
              <div className="close" onClick={this.handleCloseDownloadModal}>
                <img 
                  alt=""
                  src={utils.formatImgUrl("https://static.shihuocdn.cn/admin/files/20230227/3824f46f10ed91f4d71e53c141c9ebf4.png", this.props.webpSupport)}
                  style={{
                    width: px2rem('24px'),
                    height: 'auto',
                  }}
                />
              </div>
            </div>
        </div>
        }
      </div>
    );
  }
}

PipelineImgList.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgList };
export default PipelineImgList;



// WEBPACK FOOTER //
// ./components/pipeline-imgList/index.js